import React from "react";
import Text from "@ui/Text";
import { css } from "@linaria/core";
import { colors, fonts, spacings } from "@ui/Theme";
import t from "../../../../../i18n";
import { Action } from "..";

export const EventChartTooltip = ({
  eventName,
  status,
  priority,
  link,
}: {
  eventName: string;
  status: string;
  priority: string;
  link?: string | null;
}) => (
  <div className={faultEventChartTooltip}>
    <div>
      <Text type="body1">{t("diagnosis.chart.tooltip.event.title")}</Text>
      {link ? (
        <Action className={customAction} href={link} target="_blank" rel="noreferrer">
          <Text type="body1">{t("diagnosis.chart.tooltip.event.link")}</Text>
        </Action>
      ) : null}
    </div>
    <div>
      <Text type="body1SemiBold" as="span">
        {eventName}
      </Text>
    </div>
    <div>
      {t("commun.tooltip.label_value", {
        label: (
          <Text type="body1" as="span">
            {t("project.fault_events.table.live.metadata.status")}
          </Text>
        ),
        value: (
          <Text type="body1SemiBold" as="span">
            {status}
          </Text>
        ),
      })}
    </div>
    <div>
      {t("commun.tooltip.label_value", {
        label: (
          <Text type="body1" as="span">
            {t("project.plant_state.block.priority_event.table.priority")}
          </Text>
        ),
        value: (
          <Text type="body1SemiBold" as="span">
            {priority}
          </Text>
        ),
      })}
    </div>
  </div>
);

//#region
const faultEventChartTooltip = css`
  display: flex;
  flex-direction: column;
  gap: ${spacings.xxs};
  color: ${colors.carbon800};

  & > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > *:nth-child(1) {
      color: ${colors.carbon800};
    }
  }
`;

const customAction = css`
  font: ${fonts.body1};
`;
//#endregion
